module.exports = __webpack_public_path__ + "static/media/instagram-android.61ffb019.png";